import { SubscriptionsApi } from "@jti/rest-api";
import type { SubscriptionsConfiguration } from "@jti/rest-api-types";

import { TAGS } from "../common/tags";
import type { SubscriptionApiBuilder } from "../subscriptionApiSlice.types";

export const getSubscriptionConfigurationsEndpoint = (builder: SubscriptionApiBuilder) => ({
  getSubscriptionConfigurations: builder.query<SubscriptionsConfiguration, void>({
    queryFn: async () => {
      const subscriptionsApi = SubscriptionsApi.init();
      const response = await subscriptionsApi.getSubscriptionConfigurations();
      return { data: response };
    },
    providesTags: [TAGS.SUBSCRIPTION],
  }),
});
